import React, { useEffect, useMemo, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Select from "react-select";
import { useDispatch } from "react-redux";
import CustomBtn from "components/fragments/CustomBtn";
import { masterHandler } from "../../redux/handlers";

export default function ModalVoidBill({
  modalOpenObj,
  modalStockConfirmationOpenObj,
  voidObj,
}) {
  const dispatch = useDispatch();

  const [voidRemarks, setVoidRemarks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const data = await dispatch(masterHandler.getVoidRemarks());
        if (mounted && Array.isArray(data)) {
          setVoidRemarks(data);
        }
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [dispatch]);

  const optionsReason = useMemo(
    () => (voidRemarks || []).map((x) => ({ value: x.id, label: x.name })),
    [voidRemarks]
  );

  const selectedReason = useMemo(
    () =>
      optionsReason.find((o) => o.value === voidObj?.billvoiddata?.reason_id) ||
      null,
    [optionsReason, voidObj?.billvoiddata?.reason_id]
  );

  const isConfirmDisabled = !voidObj?.billvoiddata?.reason_id;

  const handleConfirmClick = async () => {
    if (!voidObj?.billvoiddata?.reason_id) return;

    try {
      modalOpenObj.setModalOpen(false);
      if (modalStockConfirmationOpenObj?.setModalOpen) {
        console.log("handleConfirmClick : xxx");

        modalStockConfirmationOpenObj.setModalOpen(true);
      }
    } catch (error) {
      console.error("Error opening stock confirmation modal:", error);
    }
  };

  const handleClose = () => {
    modalOpenObj.setModalOpen(false);

    if (voidObj?.setBillvoiddata) {
      voidObj.setBillvoiddata({
        reason_id: null,
        reason_label: "",
        note: "",
      });
    }
  };

  return (
    <Modal
      aria-labelledby="void-bill-title"
      open={modalOpenObj.modalOpen}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 300 } }}
    >
      <Fade in={modalOpenObj.modalOpen}>
        <div className="bg-white w-[min(37.11vw,380px)] px-4 py-3 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16">
          <div
            id="void-bill-title"
            className="mb-4 text-22 font-[700] leading-[2.2]"
          >
            ยกเลิกบิล ( VOID )
          </div>

          <div className="mb-2 text-[15px] font-[600]">เหตุผล</div>
          <div className="mb-4 select-3">
            <Select
              className="w-100 select-arrow"
              options={optionsReason}
              isLoading={loading}
              placeholder="เลือกเหตุผล"
              value={selectedReason}
              onChange={(opt) => {
                voidObj.setBillvoiddata((prev) => ({
                  ...prev,
                  reason_id: opt?.value ?? null,
                  reason_label: opt?.label ?? "",
                }));
              }}
              noOptionsMessage={() =>
                loading ? "กำลังโหลด..." : "ไม่พบข้อมูล"
              }
            />
          </div>

          <div className="d-flex align-items-center mb-1">
            <div className="me-auto fs-14">หมายเหตุ</div>
            <button
              type="button"
              className="btn btn-link p-0 text-danger fs-14"
              onClick={() =>
                voidObj.setBillvoiddata((prev) => ({
                  ...prev,
                  note: "",
                }))
              }
            >
              ล้าง
            </button>
          </div>

          <textarea
            className="form-control fs-14"
            rows="4"
            value={voidObj?.billvoiddata?.note || ""}
            onChange={(e) =>
              voidObj.setBillvoiddata((prev) => ({
                ...prev,
                note: e.target.value,
              }))
            }
            placeholder="ระบุรายละเอียดเพิ่มเติม (ถ้ามี)"
          />

          <div className="mt-4 pt-3 mb-3 flex justify-center gap-[min(2.01vw,20.63px)]">
            <CustomBtn
              onClick={handleClose}
              className="leading-[0.8] w-fit text-18 text-[#6D788D] font-[600] px-4 py-3 rounded-[min(0.78vw,8px)] btn-second-2-active shadow-none"
              btntxt="ยกเลิก"
            />
            <CustomBtn
              onClick={handleConfirmClick}
              disabled={isConfirmDisabled}
              className={`leading-[0.8] w-fit text-18 text-white font-[600] px-4 py-3 rounded-[min(0.78vw,8px)] btn-main-active shadow-none ${
                isConfirmDisabled ? "opacity-60 cursor-not-allowed" : ""
              }`}
              btntxt="ยืนยัน"
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
